import firebase from "firebase/app";
import "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyB9SbnKEJ5fXStE4FVG1_rHtVBpwD7HLYg",
  authDomain: "events-slothtech.firebaseapp.com",
  databaseURL: "https://events-slothtech.firebaseio.com",
  projectId: "events-slothtech",
  storageBucket: "events-slothtech.appspot.com",
  messagingSenderId: "1073006839870",
  appId: "1:1073006839870:web:ddf5c563d9e9828077a96f",
  measurementId: "G-LSSP62BNDL"
};
firebase.initializeApp(firebaseConfig);


export default firebase;
